import { render, staticRenderFns } from "./TopCambodia.vue?vue&type=template&id=423ed65b"
import script from "./TopCambodia.vue?vue&type=script&lang=js"
export * from "./TopCambodia.vue?vue&type=script&lang=js"
import style0 from "./TopCambodia.vue?vue&type=style&index=0&id=423ed65b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports